import React, { Component } from "react";
import LoadingPage from "@components/Loading/Loading";
import Table from "@components/Table/TableDevice";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import {
  MdClose,
  MdCloudUpload,
  MdInsertDriveFile,
  MdFileDownload,
  MdAdd,
  MdCloudDownload,
  MdSync,
} from "react-icons/md";
import config from "@config";
import apiEndpoints from "@store/apiEndpoints";
import errorFunctions from "@store/errorFunctions";
import referenceLibrary from "@store/referenceLibrary";
import utilityFunctions from "@store/utilityFunctions";
import { useToast } from "@components/Toast/ToastContext";
import DeviceAdd from "./DeviceAdd/DeviceAdd";
import Cin7ImportModal from "./Cin7ImportModal";
import "../common.css";
import "./Device.css";

class Device extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      statusFilter: "All",
      searchFilter: "",
      statusSelector: 0,
      devices: [],
      deviceId: undefined,
      showAddDevice: false,
      showBulkImport: false,
      showCin7Import: false,
      isEdit: false,
      rowDevice: undefined,
      allowUpload: false,
      fileName: "",
      isImporting: false,
      isDragOver: false,
      importErrors: null,
      // Pagination states
      currentPage: 1,
      pageSize: 15,
      totalItems: 0,
      totalPages: 0,
      ordering: "id",
    };
    this.user = utilityFunctions.getUserInfo()?.user;
    this.userRole = this.user?.role;
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    this.retrieveDevice();
    console.log(
      "this.props.userInfo?.user ",
      this.props.userInfo?.user?.brands,
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedbrandID !== prevProps.selectedbrandID) {
      this.setState({ currentPage: 1 }, () => {
        this.retrieveDevice();
      });
    }
  }

  getUserBrands() {
    const userBrands = this.props.userInfo?.user?.brands || [];
    const country = config.country;

    return country
      ? userBrands.filter((brand) => brand.country === country)
      : userBrands;
  }

  retrieveDevice() {
    this.setState({
      isLoading: true,
    });

    const { currentPage, pageSize, searchFilter } = this.state;

    // Build query parameters
    let url = `${apiEndpoints.device.list()}?page=${currentPage}&limit=${pageSize}`;

    if (this.state.ordering) {
      url += `&ordering=${this.state.ordering}`;
    }

    if (searchFilter) {
      url += `&q=${encodeURIComponent(searchFilter)}`;
    }

    const filteredBrands = this.getUserBrands();

    const brandIds = filteredBrands.map((brand) => brand.id).join(",");

    const brandParam = this.props.selectedbrandID
      ? `&brandId=${this.props.selectedbrandID}`
      : brandIds
        ? `&brandId=${brandIds}`
        : "";

    if (brandParam) {
      url += brandParam;
    }

    this.props
      .protectedFetch(url, "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        const devices = res.results || [];
        const total = res.count;
        const totalPages = res.totalPages || Math.ceil(total / pageSize);

        this.setState({
          devices: devices,
          totalItems: total,
          totalPages: totalPages,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  filterChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  handleSearch = () => {
    // Reset to first page when searching
    this.setState({ currentPage: 1 }, () => {
      this.retrieveDevice();
    });
  };

  handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSearch();
    }
  };

  handlePageChange = (newPage) => {
    this.setState({ currentPage: newPage }, () => {
      this.retrieveDevice();
    });
  };

  handlePageSizeChange = (newPageSize) => {
    this.setState(
      {
        pageSize: newPageSize,
        currentPage: 1,
      },
      () => {
        this.retrieveDevice();
      },
    );
  };

  handleExport = () => {
    this.setState({ isLoading: true });
    this.props
      .protectedFetch(apiEndpoints.device.export(), "GET", null, (response) => {
        const disposition = response.headers.get("content-disposition");
        return response.blob().then((blob) => ({ blob, disposition }));
      })
      .then(({ blob, disposition }) => {
        const filename = disposition
          ? disposition.split("filename=")[1]?.replace(/"/g, "")
          : `Export_devices_${new Date().toISOString()}.csv`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.props.showToast("Export failed. Please try again.", "error");
        this.setState({ isLoading: false });
      });
  };

  handleOpenCin7Import = () => {
    this.setState({ showCin7Import: true });
  };

  handleDownloadTemplate = () => {
    const filteredBrands = this.getUserBrands();

    const header =
      "brand_name,sku,category_name,name,weight,height,width,length,description,shipping_vendor";
    const brandRows = filteredBrands
      .map((b) => `${b.name},,,,,,,,, `)
      .join("\n");
    const notes = [
      "# NOTES:,,,,,,,,,,",
      "# - brand_name (required): Must exactly match an existing brand name in the system.,,,,,,,,,,",
      "# - sku (required): If provided, must be unique across all devices.,,,,,,,,,,",
      "# - category_name (required): Must exactly match an existing category name in the system.,,,,,,,,,,",
      "# - name (required): Name of the device.,,,,,,,,,,",
    ].join("\n");
    const csvContent = [header, brandRows, notes].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "device_bulk_upload_template.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  handleDropzoneDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: false });
    const file = e.dataTransfer.files[0];
    if (!file) return;
    this.processFile(file);
  };

  handleDropzoneDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: true });
  };

  handleDropzoneDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragOver: false });
  };

  processFile = (file) => {
    const allowedTypes = ["text/csv", "application/vnd.ms-excel"];
    if (!allowedTypes.includes(file.type) && !file.name.endsWith(".csv")) {
      this.props.showToast("Only CSV files are allowed.", "error");
      this.setState({ allowUpload: false, fileName: "", selectedFile: null });
    } else {
      this.setState({
        allowUpload: true,
        fileName: file.name,
        selectedFile: file,
      });
    }
  };

  handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    this.processFile(file);
  };

  handleSubmitBulkImport = () => {
    if (!this.state.allowUpload) {
      this.props.showToast("Please select a valid CSV file.", "warning");
      return;
    }
    const file = this.state.selectedFile || this.fileInputRef.current?.files[0];
    const formData = new FormData();
    formData.append("file", file);

    this.setState({ isImporting: true, importErrors: null });

    const token = utilityFunctions.getAccessToken();

    fetch(apiEndpoints.device.import(), {
      method: "POST",
      headers: { Authorization: "Bearer " + token },
      body: formData,
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw errorData;
        }
        return response.json();
      })
      .then(() => {
        this.setState({
          showBulkImport: false,
          allowUpload: false,
          fileName: "",
          selectedFile: null,
          isImporting: false,
          importErrors: null,
        });
        this.retrieveDevice();
        this.props.showToast("Import completed successfully.", "success");
      })
      .catch((errorData) => {
        const importErrors = errorData?.errors || null;
        this.setState({ isImporting: false, importErrors });
        if (!importErrors) {
          this.props.showToast(
            "Import failed. Please check your file and try again.",
            "error",
          );
        }
      });
  };

  handleRequestSort = (event, property) => {
    const isAsc = this.state.ordering === property;
    const newOrdering = isAsc ? `-${property}` : property;

    this.setState(
      {
        ordering: newOrdering,
      },
      () => {
        this.retrieveDevice();
      },
    );
  };

  handleFilterStatus = (val) => {
    const statusText =
      referenceLibrary.statusSelectors.find((x) => x.id === parseInt(val))
        ?.name || "";
    if (statusText === "") this.setState({ statusFilter: "All" });
    else this.setState({ statusFilter: "status", statusSelector: statusText });
  };

  statusFilterChange = (value) => {
    this.setState({ statusFilter: value });
  };

  formatValueWithCommas = (value) => {
    if (value === "") return value;

    const parts = value.toString().split(".");
    let formattedValue = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (parts.length > 1) {
      const decimalPart = parts[1].slice(0, 2);
      formattedValue += `.${decimalPart}`;
    }

    return formattedValue;
  };

  render() {
    const tableHead = [
      {
        id: "id",
        label: "Device ID",
        width: "2vw",
        valueDisplay: (value) => value,
      },
      {
        id: "sku",
        label: "SKU",
        width: "24vw",
        valueDisplay: (value) => value || "—",
      },
      {
        id: "name",
        label: "Dreame Model",
        width: "30vw",
        valueDisplay: (value) => value,
      },
      {
        id: "width",
        label: "Width",
        width: "3vw",
        valueDisplay: (value) => value,
      },
      {
        id: "length",
        label: "Length",
        width: "3vw",
        valueDisplay: (value) => value,
      },
      {
        id: "height",
        label: "Height",
        width: "3vw",
        valueDisplay: (value) => value,
      },
      {
        id: "weight",
        label: "Weight",
        width: "3vw",
        valueDisplay: (value) => value,
      },
      {
        id: "description",
        label: "Descriptions",
        width: "15vw",
        valueDisplay: (value) => value,
      },
      {
        id: "shipping_vendor",
        label: "Shipping Vendor",
        width: "10vw",
        valueDisplay: (value) => value,
      },
      {
        id: "action",
        label: "Action",
        valueDisplay: (value) => value || "",
      },
    ];

    return (
      <div>
        {this.state.isLoading && <LoadingPage />}
        <div className={"page"}>
          <div className="d-flex justify-content-between">
            <div
              style={{
                width: "100px",
                borderBottom: "1px solid black",
                textAlign: "center",
              }}
            >
              <h5>Devices</h5>
            </div>
            <div className="d-flex gap-2">
              <button
                className="k-btn k-btn-primary k-btn-sm d-flex gap-2"
                onClick={this.handleOpenCin7Import}
              >
                <MdSync className="my-auto" title="Import from Cin7" />
                <span className="my-auto">Import from Cin7</span>
              </button>
              <button
                className="k-btn k-btn-primary k-btn-sm d-flex gap-2"
                onClick={this.handleExport}
              >
                <MdFileDownload
                  className="my-auto"
                  title="Export all devices"
                />
                <span className="my-auto">Export</span>
              </button>
              <button
                className="k-btn k-btn-primary k-btn-sm d-flex gap-2"
                onClick={() =>
                  this.setState({
                    showBulkImport: true,
                    allowUpload: false,
                    fileName: "",
                    importErrors: null,
                  })
                }
              >
                <MdCloudUpload
                  className="my-auto"
                  title="Bulk import devices"
                />
                <span className="my-auto">Bulk Import</span>
              </button>
              <Link to={"/device-detail/new"} className="text-decoration-none">
                <button className="k-btn k-btn-primary k-btn-sm d-flex gap-2">
                  <MdAdd className="my-auto" title="Add new device" />
                  <span className="my-auto">Add New Device</span>
                </button>
              </Link>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-2">
            <div className="mt-1">
              <div className="input-group mb-3 position-relative bottom-0 end-0">
                <input
                  type="text"
                  placeholder="Search device"
                  id={"searchFilter"}
                  className={"form-control"}
                  onChange={this.filterChange}
                  onKeyPress={this.handleSearchKeyPress}
                  value={this.state.searchFilter}
                />
                <div className="input-group-prepend">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={this.handleSearch}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {this.state.devices.length > 0 || this.state.isLoading ? (
            <div className={"pageContent clearfix"}>
              <div className={"admin-table-container card"}>
                <Table
                  head={tableHead}
                  data={this.state.devices}
                  reloadDevice={() => this.retrieveDevice()}
                  protectedFetch={this.props.protectedFetch}
                  selectedbrandID={this.props.selectedbrandID}
                  role={this.userRole}
                  statusSelectors={referenceLibrary.statusSelectors}
                  filteredStatus={this.handleFilterStatus}
                  editDevice={(row) =>
                    this.setState({
                      showAddDevice: true,
                      isEdit: true,
                      rowDevice: row,
                    })
                  }
                  handleRequestSort={this.handleRequestSort}
                  order={this.state.ordering}
                  orderBy={this.state.ordering}
                  // Pass pagination props
                  usePagination={true}
                  currentPage={this.state.currentPage}
                  pageSize={this.state.pageSize}
                  totalItems={this.state.totalItems}
                  totalPages={this.state.totalPages}
                  onPageChange={this.handlePageChange}
                  onPageSizeChange={this.handlePageSizeChange}
                />
              </div>
            </div>
          ) : (
            <div>No device</div>
          )}
        </div>
        <Modal
          isOpen={this.state.showBulkImport}
          contentLabel={"Bulk Import Devices"}
          className={"input-modal"}
        >
          <div className="device-import-modal-container">
            <div className="device-import-card">
              <button
                onClick={() =>
                  this.setState({ showBulkImport: false, importErrors: null })
                }
                className="device-import-close-btn"
                aria-label="Close"
              >
                <MdClose size={22} />
              </button>

              <div className="device-import-header">
                <div className="device-import-header-icon">
                  <MdCloudUpload size={32} />
                </div>
                <h2 className="device-import-title">Bulk Import Devices</h2>
                <p className="device-import-subtitle">
                  Upload a CSV file to import multiple devices at once
                </p>
              </div>

              <div className="device-import-body">
                <p className="device-import-description">
                  Select a CSV file containing device data. Make sure the file
                  follows the required format before uploading.
                </p>

                <div
                  onClick={this.handleDownloadTemplate}
                  className="device-import-template-link"
                >
                  <MdCloudDownload size={16} />
                  Download Template
                </div>

                <div className="device-import-upload-group">
                  <label className="device-import-label">
                    CSV File <span style={{ color: "#dc3545" }}>*</span>
                  </label>

                  {this.state.fileName ? (
                    <div className="device-import-file-selected">
                      <MdInsertDriveFile
                        size={20}
                        className="device-import-file-selected-icon"
                      />
                      <span className="device-import-file-name">
                        {this.state.fileName}
                      </span>
                      <button
                        onClick={() => {
                          this.setState({
                            fileName: "",
                            allowUpload: false,
                            selectedFile: null,
                          });
                          if (this.fileInputRef.current)
                            this.fileInputRef.current.value = "";
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "#999",
                          padding: 0,
                          display: "flex",
                        }}
                      >
                        <MdClose size={18} />
                      </button>
                    </div>
                  ) : (
                    <div
                      className={`device-import-dropzone${this.state.isDragOver ? " device-import-dropzone--active" : ""}`}
                      onClick={() =>
                        this.fileInputRef.current &&
                        this.fileInputRef.current.click()
                      }
                      onDragOver={this.handleDropzoneDragOver}
                      onDragLeave={this.handleDropzoneDragLeave}
                      onDrop={this.handleDropzoneDrop}
                    >
                      <input
                        accept=".csv,text/csv"
                        type="file"
                        style={{ display: "none" }}
                        ref={this.fileInputRef}
                        onChange={this.handleFileUpload}
                      />
                      <div className="device-import-dropzone-icon">
                        <MdCloudUpload size={36} />
                      </div>
                      <p className="device-import-dropzone-text">
                        Click to browse or drag &amp; drop
                      </p>
                      <p className="device-import-dropzone-hint">
                        CSV files only
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {this.state.importErrors &&
                this.state.importErrors.length > 0 && (
                  <div className="device-import-errors">
                    <p className="device-import-errors-title">
                      Import failed. Please fix the following errors:
                    </p>
                    <ul className="device-import-errors-list">
                      {this.state.importErrors.map((rowError, idx) => (
                        <li key={idx}>
                          <strong>Row {rowError.row}:</strong>{" "}
                          {rowError.errors.join(", ")}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

              <div className="device-import-footer">
                <div className="device-import-footer-buttons">
                  <button
                    className="device-import-btn device-import-btn--secondary"
                    onClick={() =>
                      this.setState({
                        showBulkImport: false,
                        fileName: "",
                        allowUpload: false,
                        selectedFile: null,
                        importErrors: null,
                      })
                    }
                    disabled={this.state.isImporting}
                  >
                    Cancel
                  </button>
                  <button
                    className="device-import-btn device-import-btn--primary"
                    onClick={this.handleSubmitBulkImport}
                    disabled={this.state.isImporting || !this.state.allowUpload}
                  >
                    {this.state.isImporting ? (
                      <>
                        <span className="device-import-spinner" />
                        Uploading...
                      </>
                    ) : (
                      <>
                        <MdCloudUpload size={18} />
                        Upload
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Cin7ImportModal
          isOpen={this.state.showCin7Import}
          onClose={() => this.setState({ showCin7Import: false })}
          brands={this.getUserBrands()}
          protectedFetch={this.props.protectedFetch}
          onImportSuccess={() => {
            this.setState({ showCin7Import: false });
            this.retrieveDevice();
          }}
        />
        <Modal
          isOpen={this.state.showAddDevice}
          contentLabel={"Add Device"}
          className={"input-modal"}
        >
          <DeviceAdd
            protectedFetch={this.props.protectedFetch}
            handleCloseModal={() =>
              this.setState({ showAddDevice: false, isEdit: false })
            }
            reloadDevice={() => this.retrieveDevice()}
            selectedBrandId={this.props.selectedbrandID}
            isEdit={this.state.isEdit}
            deviceData={this.state.rowDevice}
          />
        </Modal>
      </div>
    );
  }
}

function DeviceWithToast(props) {
  const { showToast } = useToast();
  return <Device {...props} showToast={showToast} />;
}

export default DeviceWithToast;
